import { getFirestore, doc, getDoc, setDoc, increment, Timestamp, } from "firebase/firestore";
import { mapFirebaseError } from "./errorMapper";
const LIMITS = {
    post: { windowSec: 3600, max: 5 },
    comment: { windowSec: 300, max: 3 },
    contact: { windowSec: 86400, max: 3 },
    report: { windowSec: 3600, max: 5 },
};
// §2.4 — exact per-action Arabic messages. `contact` has no {time} substitution (fixed "try tomorrow" copy).
const BLOCKED_MESSAGES = {
    post: (time) => `لقد تجاوزت الحد المسموح لنشر الخدمات، يرجى الانتظار ${time}`,
    comment: (time) => `أرسلت تعليقات كثيرة، يرجى الانتظار ${time}`,
    contact: () => "لقد أرسلت رسائل كافية اليوم، يرجى المحاولة غداً",
    report: (time) => `تجاوزت حد الإبلاغات، يرجى الانتظار ${time}`,
};
function formatRemaining(ms) {
    const seconds = Math.max(1, Math.ceil(ms / 1000));
    if (seconds < 60)
        return `${seconds} ثانية`;
    if (seconds < 3600)
        return `${Math.ceil(seconds / 60)} دقيقة`;
    return `${Math.ceil(seconds / 3600)} ساعة`;
}
export class FirebaseRateLimitRepository {
    db = getFirestore();
    async isAllowed(action, userId) {
        try {
            const ref = doc(this.db, "rate_limits", userId, "actions", action);
            const snap = await getDoc(ref);
            if (!snap.exists())
                return { allowed: true, message: null };
            const data = snap.data();
            const limit = LIMITS[action];
            const now = Date.now();
            const resetAt = data.resetAt?.toMillis() ?? 0;
            if (now >= resetAt)
                return { allowed: true, message: null };
            if (data.count < limit.max)
                return { allowed: true, message: null };
            return { allowed: false, message: BLOCKED_MESSAGES[action](formatRemaining(resetAt - now)) };
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async record(action, userId) {
        try {
            const ref = doc(this.db, "rate_limits", userId, "actions", action);
            const snap = await getDoc(ref);
            const limit = LIMITS[action];
            const now = Date.now();
            if (!snap.exists() || now >= snap.data().resetAt?.toMillis()) {
                await setDoc(ref, {
                    count: 1,
                    resetAt: Timestamp.fromMillis(now + limit.windowSec * 1000),
                });
            }
            else {
                await setDoc(ref, { count: increment(1) }, { merge: true });
            }
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebaseRateLimitRepository.js.map